export const getArticleGroupId = ({ theme, id, locale }: { theme: Content.Theme; id: string; locale: string }) => {
	return `${theme}_${id}_${locale}`;
};
